/* eslint-disable max-len */
import React from 'react';
import ReactDOM from 'react-dom';
import TrackingCopyingText from '../../src/news_show/tracking_copying_text/tracking_copying_text';
import TrackReadingProgress from '../../src/news_show/track_reading_progress/track_reading_progress';
import AdButler from '../../src/components/react/adbutler/adbutler';
import ShareContentToolbar from '../../src/news_show/share_content_toolbar/share_content_toolbar';
import ArticleNewsletterSubscription from '../../src/news_show/article_newsletter_subscription/article_newsletter_subscription';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import Tooltip from 'bootstrap/js/dist/tooltip';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('article-root');
  const isSignedIn = JSON.parse(root.dataset.isSignedIn);

  const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipElements.forEach((element) => new Tooltip(element));

  const trackingCopyingText = document.getElementById('tracking-copying-text');
  if (trackingCopyingText) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <TrackingCopyingText
          querySelector={trackingCopyingText.dataset.querySelector}
          minCopyLength={JSON.parse(trackingCopyingText.dataset.minCopyLength)}
        />
      </DevexHighOrderComponent>,
      trackingCopyingText
    );
  }

  const trackReadingProgress = document.getElementById('track-reading-progress');
  if (trackReadingProgress) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <TrackReadingProgress articleId={trackReadingProgress.dataset.articleId} />
      </DevexHighOrderComponent>,
      trackReadingProgress
    );
  }

  const adbutlerSidebarSquare = document.getElementById('adbutler-sidebar-square');
  if (adbutlerSidebarSquare) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <AdButler
          adbutlerInfo={JSON.parse(adbutlerSidebarSquare.dataset.adbutlerInfo)}
          isSignedIn={isSignedIn}
        />
      </DevexHighOrderComponent>,
      adbutlerSidebarSquare
    );
  }

  const adbutlerSidebarTower = document.getElementById('adbutler-sidebar-tower');
  if (adbutlerSidebarTower) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <AdButler
          adbutlerInfo={JSON.parse(adbutlerSidebarTower.dataset.adbutlerInfo)}
          isSignedIn={isSignedIn}
        />
      </DevexHighOrderComponent>,
      adbutlerSidebarTower
    );
  }

  const newsletterSubscriptions = document.querySelectorAll('.newsletter-subscription-component');
  if (newsletterSubscriptions.length) {
    newsletterSubscriptions.forEach((newsletterSubscription) => {
      ReactDOM.render(
        <DevexHighOrderComponent>
          <ArticleNewsletterSubscription
            articleId={newsletterSubscription.dataset.articleId}
            isSignedIn={JSON.parse(newsletterSubscription.dataset.isSignedIn)}
          />
        </DevexHighOrderComponent>,
        newsletterSubscription
      );
    });
  }

  const shareContentToolbar = document.getElementById('share-content-toolbar');
  if (shareContentToolbar) {
    const {
      contentId,
      contentUrl,
      contentTitle,
      contentTeaser,
      showSharingArticle,
      isArticlePaywalled,
    } = shareContentToolbar.dataset;

    ReactDOM.render(
      <ShareContentToolbar
        contentId={parseInt(contentId)}
        contentUrl={contentUrl}
        contentTitle={contentTitle}
        contentTeaser={contentTeaser}
        showSharingArticle={showSharingArticle === 'true'}
        isArticlePaywalled={isArticlePaywalled === 'true'}
      />,
      shareContentToolbar
    );
  }
});
